import { createStore, stateSetterHandler } from '@alpha.apps/react-common';

import { settingsModel } from '../../services';

export type CmsSettingState = {
  setting: Partial<settingsModel>;
};
const initState: CmsSettingState = {
  setting: {
    OTPCountDown: 0,
    experienceDescription: '',
    foodMenuUrl: '',
    voucherRedemptionDescription: '',
    contactUsDescription: '',
    offerDescription: '',
    foodMenuDescription: '',
    tempLoginVistaIssue: '',
    minAmountTopUp: 0,
    maxAmountTopUp: 0,
  },
};

export const useCmsSetting = createStore({
  name: 'setting',
  devtools: true,
  persist: false,
})(initState, set => {
  const handler = stateSetterHandler(set);
  return {
    setCmsSetting: handler('setting'),
  };
});
